// components/ai/ahamoment/AnswerBox.jsx
import React from 'react';
import { FaRegCommentDots } from 'react-icons/fa';

const AnswerBox = ({ children }) => {
  return (
    <div style={{
      backgroundColor: '#2C2F36',
      color: '#FFFFFF',
      borderRadius: '16px',
      padding: '1rem',
      marginBottom: '1rem',
      fontFamily: 'Nunito Sans',
      boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
    }}>
      <div style={{
        fontWeight: '700',
        marginBottom: '0.75rem',
        fontSize: '17px',
        color: '#FF7C24',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
      }}>
        <FaRegCommentDots /> Answer
      </div>
      <div style={{ fontSize: '16px', lineHeight: '1.6' }}>{children}</div>
    </div>
  );
};

export default AnswerBox;
